<template>
    <v-container>
        <v-card shaped class="mx-md-4 my-md-4 pa-4">
            <v-row>
                <v-col cols="12">
                    <v-toolbar
                        flat
                        color="#1d2735"
                        dark
                        style="border-radius: 5px"
                    >
                        <v-icon class="white--text" style="font-size: 45px"
                            >mdi-account-supervisor-circle</v-icon
                        >
                        <pre><v-toolbar-title><h2>Crear seguimiento</h2></v-toolbar-title></pre>
                    </v-toolbar>
                    <v-form ref="form" v-model="validForm" class="mt-3">
                        <v-col cols="12">
                            <router-link to="lista-seguimiento">
                                <v-btn color="red" class="white--text" s>
                                    Volver
                                </v-btn>
                            </router-link>
                        </v-col>
                        <v-row>
                            <v-col cols="12" md="3">
                                <v-autocomplete
                                    @update:search-input="SearchCliente"
                                    v-model="seguimiento.id_cliente"
                                    :items="clientes"
                                    item-text="nombre_comercial"
                                    item-value="id"
                                    label="Cliente"
                                    :rules="[rules.required]"
                                    @change="getAgentes"
                                >
                                    <template v-slot:append-item>
                                        <div v-intersect="endIntersect" />
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <!--<v-col cols="12" md="4">
                                <v-autocomplete
                                    v-model="seguimiento.id_producto"
                                    :items="productos"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Proyecto"
                                >
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-switch
                                v-model="seguimiento.confirmado"
                                :label="seguimiento.confirmado?`Confimado`:`Sin confirmar`"
                                ></v-switch>
                            </v-col>
                             <v-col cols="12" md="4">
                                <dynamic_select
                                    title="Acción"
                                    v-bind:estados="acciones"
                                    show="nombre"
                                    :elemento="seguimiento.id_accion"
                                    @create="createAccion"
                                    @delete="deleteAccion"
                                    @getEstado="updateAccion"
                                    @update="createAccion"
                                    @elementoUpdate="updatethisAccion"
                                >
                                <v-row>
                                    <v-col cols="12">
                                        <v-text-field
                                        label="Nombre"
                                        v-model="accion.nombre"
                                        >

                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                </dynamic_select>
                            </v-col>-->
                            <v-col cols="12" md="3" v-if="rol != 4 && rol != 5">
                                <v-autocomplete
                                    v-model="seguimiento.id_agente"
                                    :items="agentes"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Agente"
                                >
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="3">
                                <date-select
                                    v-model="seguimiento.fecha"
                                    label="Fecha"
                                    :rules="[rules.required]"
                                >
                                </date-select>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    outlined
                                    v-mask="'##:##'"
                                    label="Horas"
                                    v-model="seguimiento.hora"
                                    :rules="[rules.required]"
                                >
                                </v-text-field>
                            </v-col>
                            <!--<v-col cols="12" md="4">
                                <dynamic_select
                                    title="Control"
                                    v-bind:estados="controles"
                                    show="nombre"
                                    :elemento="seguimiento.id_control"
                                    @create="createControl"
                                    @delete="deleteControl"
                                    @getEstado="updateControl"
                                    @update="createControl"
                                    @elementoUpdate="updatethisControl"
                                >
                                <v-row>
                                    <v-col cols="12">
                                        <v-text-field
                                        label="Nombre"
                                        v-model="control.nombre"
                                        >

                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                </dynamic_select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field-comma
                                    v-model="seguimiento.ventas"
                                    label="Ventas"
                                    suffix="€"
                                    type="number">
                                </v-text-field-comma>
                            </v-col>-->
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="8">
                                <v-autocomplete
                                    v-model="seguimiento.seguimiento_users"
                                    label="Asignar usuario(s)"
                                    :items="users"
                                    item-text="name"
                                    item-value="id"
                                    multiple
                                    chips
                                    clearable
                                    :disabled="rol == 5"
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-checkbox
                                    v-model="seguimiento.aviso_email"
                                    label="Enviar aviso por email"
                                ></v-checkbox>
                            </v-col>

                            <v-col cols="12">
                                <v-text-field
                                    v-model="seguimiento.observacion"
                                    label="Observaciones"
                                    :rules="[rules.required]"
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <!--<v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="seguimiento.comentario"
                                    label="Comentarios"
                                   >
                                </v-text-field>
                            </v-col>
                        </v-row>-->
                        <v-row>
                            <v-col cols="12">
                                <router-link to="lista-seguimiento">
                                    <v-btn color="red" class="white--text" s>
                                        Cancelar
                                    </v-btn>
                                </router-link>
                                <v-btn
                                    v-if="!seguimiento.id"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text"
                                    @click="createSeguimiento"
                                    >Guardar</v-btn
                                >
                                <v-btn
                                    @click="createSeguimiento"
                                    v-if="seguimiento.id"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text"
                                    >Actualizar</v-btn
                                >
                                <v-btn
                                    @click="deleteSeguimiento"
                                    v-if="seguimiento.id"
                                    :disabled="isloading"
                                    color="red"
                                    class="white--text"
                                    >Eliminar</v-btn
                                >
                            </v-col>
                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
import { debounce } from "../../../helpers";
import { rules } from "../../../rules";
export default {
    data() {
        return {
            rules: rules,
            validForm: false,
            productos: [],
            acciones: [],
            controles: [],
            agentes: [],
            seguimiento: {
                id: null,
                id_cliente: null,
                observacion: null,
                // id_producto: null,
                // id_accion: null,
                fecha: new Date(
                    Date.now() - new Date().getTimezoneOffset() * 60000
                )
                    .toISOString()
                    .substr(0, 10),
                // id_control: null,
                // ventas: null,
                id_agente: null,
                // comentario: null,
                aviso_email: false,
                seguimiento_users: [],
            },
            //Cruds de Selects dinamicos
            accion: {
                nombre: "",
            },
            control: {
                nombre: "",
            },
        };
    },
    watch: {},
    created() {
        this.getAcciones();
        this.getControles();
        this.generateHoras();
        // this.getAgentes();
        this.getProductos();
        this.$store.dispatch("getUsers");
        if (this.$route.query.id) {
            this.getSeguimiento(this.$route.query.id);
        } else {
            if (this.rol == 5) {
                this.seguimiento.seguimiento_users.push(
                    parseInt(localStorage.getItem("user_id"))
                );
            }
            this.$store.dispatch("getClientes", this);
        }
    },
    methods: {
        generateHoras() {
            this.horas = [];
            for (let val = 9; val <= 19; val += 0.5) {
                let str = val.toString().split(".");
                let txt = "";
                if (str.length > 1) {
                    txt = str[0].toString().padStart(2, "0") + ":30";
                } else {
                    txt = val.toString().padStart(2, "0") + ":00";
                }
                this.horas.push({ text: txt, value: val });
            }
        },
        //funciones del Crud de Acciones
        SearchCliente: debounce(function (val) {
            this.$store.dispatch("searchCliente", val);
        }, 500),
        endIntersect(entries, observer, isIntersecting) {
            if (isIntersecting) {
                this.$store.dispatch("getClientesNext", this);
            }
        },
        updateAccion(index) {
            this.accion = this.acciones[index];
        },
        deleteAccion(id) {
            axios.post("api/delete-seguimiento-acciones", { id: id }).then(
                (res) => {
                    this.acciones = res.data.acciones;
                },
                (res) => {}
            );
        },
        updatethisAccion(id) {
            this.seguimiento.id_accion = id;
            //console.log(id);
        },
        createAccion() {
            axios.post("api/save-seguimiento-acciones", this.accion).then(
                (res) => {
                    this.acciones = res.data.acciones;
                    this.dialog = false;
                },
                (res) => {}
            );
        },
        getAcciones() {
            axios.get(`api/get-seguimiento-acciones`).then(
                (res) => {
                    let data = res.data;
                    this.acciones = data.acciones;
                },
                (res) => {}
            );
        },
        //funciones del Crud de Controles
        updateControl(index) {
            this.control = this.controles[index];
        },
        deleteControl(id) {
            axios.post("api/delete-seguimiento-controles", { id: id }).then(
                (res) => {
                    this.controles = res.data.controles;
                },
                (res) => {}
            );
        },
        updatethisControl(id) {
            this.seguimiento.id_control = id;
        },
        createControl() {
            axios.post("api/save-seguimiento-controles", this.control).then(
                (res) => {
                    this.controles = res.data.controles;
                    this.dialog = false;
                },
                (res) => {}
            );
        },
        getControles() {
            axios.get(`api/get-seguimiento-controles`).then(
                (res) => {
                    let data = res.data;
                    this.controles = data.controles;
                },
                (res) => {}
            );
        },
        getAgentes() {
            axios
                .get(`api/get-cliente-agentes/${this.seguimiento.id_cliente}`)
                .then(
                    (res) => {
                        this.agentes = res.data.Agentes;
                    },
                    (res) => {}
                );
        },
        getProductos() {
            axios.get(`api/get-productos`).then(
                (res) => {
                    this.productos = res.data.Productos;
                },
                (res) => {}
            );
        },

        getClientes() {
            axios.get(`api/get-clientes/-1`).then(
                (res) => {
                    this.clientes = res.data.data;
                },
                (res) => {}
            );
        },

        getSeguimiento(id) {
            axios.get(`api/get-seguimiento/${id}`).then(
                (res) => {
                    this.seguimiento.fecha = Date.parse(
                        res.data.seguimiento.fecha
                    );
                    this.seguimiento = res.data.seguimiento;
                    if (this.seguimiento.id_cliente != null) {
                        this.$store.dispatch("getClientesWithId", {
                            id: this.seguimiento.id_cliente,
                        });
                    }

                    if (this.rol == 5) {
                        this.seguimiento.seguimiento_users.push(
                            this.seguimiento.id_agente
                        );
                    }
                },
                (res) => {}
            );
        },
        deleteSeguimiento(id) {
            axios.post("api/delete-seguimiento", { id: id }).then(
                (res) => {
                    this.$router.push("lista-seguimiento");
                },
                (res) => {}
            );
        },
        createSeguimiento() {
            this.$refs.form.validate();
            if (!this.validForm) {
                return;
            }
            axios
                .post("api/save-seguimiento", this.seguimiento)
                .then((res) => {
                    this.$router.push("lista-seguimiento");
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.message);
                    } else {
                        this.$custom_error(error.response.data.message);
                    }
                });
        },
    },
    filters: {},

    computed: {
        isloading() {
            return this.$store.getters.getloading;
        },
        provincias() {
            return this.$store.getters.getprovincias;
        },
        clientes() {
            /////console.log("siva");
            let clientes_temp = this.$store.getters.getclientes;

            return clientes_temp;
        },
        rol: function () {
            return localStorage.getItem("role");
        },
        users() {
            const data = this.$store.getters.getusers;
            return data.users;
        },
    },
};
</script>
